/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import WebhookEndpointsWebhookEndpoint from './WebhookEndpointsWebhookEndpoint';

/**
 * The WebhookEndpointsBody model module.
 * @module model/WebhookEndpointsBody
 * @version v0.3
 */
export default class WebhookEndpointsBody {
  /**
   * Constructs a new <code>WebhookEndpointsBody</code>.
   * @alias module:model/WebhookEndpointsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>WebhookEndpointsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WebhookEndpointsBody} obj Optional instance to populate.
   * @return {module:model/WebhookEndpointsBody} The populated <code>WebhookEndpointsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new WebhookEndpointsBody();
      if (data.hasOwnProperty('webhook_endpoint'))
        obj.webhookEndpoint = WebhookEndpointsWebhookEndpoint.constructFromObject(data['webhook_endpoint']);
    }
    return obj;
  }
}

/**
 * @member {module:model/WebhookEndpointsWebhookEndpoint} webhookEndpoint
 */
WebhookEndpointsBody.prototype.webhookEndpoint = undefined;

